import React from 'react';
import Modal from 'react-modal';
import { CSVLink } from 'react-csv';
import CSVReader from 'react-csv-reader';
import * as CSV from 'csv-string';

import './index.scss';

Modal.setAppElement('#root');

const papaparseOptions = {
  dynamicTyping: true,
  skipEmptyLines: true,
  transformHeader: (header) => header.toLowerCase().replace(/\W/g, ''),
};

const removeDuplicates = (array, accepted_insurances, un_accepted_insurances) => {
  const seen = new Set([
    ...accepted_insurances.map((item) => item.toLowerCase()),
    ...un_accepted_insurances.map((item) => item.toLowerCase()),
  ]);
  return array.filter((item) => {
    const lowerCaseItem = item.toLowerCase();
    if (seen.has(lowerCaseItem)) {
      return false; // Duplicate, don't keep it
    } else {
      seen.add(lowerCaseItem);
      return true; // Keep it
    }
  });
};

const sampledata = [
  ['Allianz'],
  ['Assurant'],
  ['Primerica'],
  ['Esurance'],
  ['Liberty Mutual'],
];

class InsuranceListUpload extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.importCSV = this.importCSV.bind(this);
    this.parseCsvFile = this.parseCsvFile.bind(this);
    this.handleError = this.handleError.bind(this);
    this.customParser = this.customParser.bind(this);
    this.state = {
      error: false,
      csvfile: undefined,
      csvdata: [],
      fileloaded: false,
      filename: undefined,
    };
  }

  closeModal() {
    this.props.modalVisibility(false);
    this.setState({
      error: false,
    });
  }

  importCSV(result, filename) {
    let csvjsondata = CSV.parse(result);
    const csvarray = this.customParser(csvjsondata);
    this.setState({
      csvdata: csvarray,
      fileloaded: true,
    });
    this.props.addContacts(csvarray, filename);
  }

  customParser(data) {
    let parserdCSVData = [];
    for (let i = 1; i < data.length; i++) {
      parserdCSVData.push(data[i][0]);
    }
    const { accepted_insurances, un_accepted_insurances } = this.props;
    return removeDuplicates(parserdCSVData, accepted_insurances, un_accepted_insurances);
  }

  parseCsvFile(data, fileInfo) {
    const parserdCSVData = this.customParser(data);
    this.props.setUploadedInsuranceList(parserdCSVData);
    this.setState({ csvdata: parserdCSVData, fileloaded: true, filename: fileInfo.name });
  }

  handleError(error) {
    console.error('Error:', error);
    this.setState({
      error: true,
    });
  }

  // Function to trigger the hidden file input
  static triggerFileInput() {
    document.getElementById('hiddenCSVInput').click();
  }

  render() {
    const { modelopen } = this.props;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className="Modal"
          overlayClassName="overlay-top"
          contentLabel="Example Modal"
        >
          <div>
            <div>
              <div className="modal-header">
                <div className="title">Import insurance list</div>
                <button className="modal-close" onClick={this.closeModal}>
                  <i className="material-icons">close</i>
                </button>
                <div className="sub-title">
                  Not sure how to format the file?
                  <span className="sample-download"><CSVLink filename="sample.csv" data={sampledata}>Download CSV template</CSVLink></span>
                </div>
              </div>
              <div className="upload-methods">
                <CSVReader
                  onFileLoaded={(data, fileInfo) => this.parseCsvFile(data, fileInfo)}
                  onError={this.handleError}
                  parserOptions={papaparseOptions}
                  inputId="hiddenCSVInput"
                />
                <div className="upload-methods_container" onClick={InsuranceListUpload.triggerFileInput}>
                  <div className="method-icon">
                    <i className="material-icons">arrow_upward</i>
                  </div>
                  <div className="method-description">
                    <div className="method-description_name">
                      Upload a file
                    </div>
                    <div className="method-description_detail">
                      Import insurance list from a CSV.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default InsuranceListUpload;
